import React, { ReactNode, useEffect, useRef } from 'react'
import cn from 'classnames'
import Icon from 'meinian-package/src/component/icon'
import UploadImg from 'baseComponent/uploadImg'
import request from 'meinian-package/src/utils/request'
import util from 'meinian-package/src/utils/util'
import css from './textbox.module.less'

export type TextboxProps = {
  className?: string
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
  children?: ReactNode
}
export default function Textbox(props: TextboxProps) {
  const { className, placeholder, value, onChange, children } = props
  const $input = useRef(null)
  useEffect(() => {
    $input.current.focus()
  }, [])
  const onUpload = async (img) => {
    await request.get('/zhikuan/search/add-image-search-history', { params: { mainUrl: img } })
    util.track('mn-header-link', {
      module1: '顶部导航',
      module2: '智能搜图',
    })
    window.open(`/imageSearch?mainUrl=${encodeURIComponent(img)}&originUrl=${encodeURIComponent(img)}`)
  }
  return (
    <div
      className={cn(css.root, className)}
      onClick={() => {
        $input.current.focus()
      }}
    >
      <span className={css.icon}>
        <Icon type="m-sousuo" />
      </span>
      {children}
      <input
        ref={$input}
        className={css.input}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value?.length > 0 && (
        <div className={css.clear} onClick={() => onChange('')}>
          清除
        </div>
      )}
      <UploadImg setUrl={img => onUpload(img)} maxFileSize={5}>
        <div
          className={css['upload-icon']}
          onClick={() => {
            util.track('mn-header-link', {
              module1: '顶部导航',
              module2: '搜索框',
              module3: '智能图搜',
            })
          }}
        >
          <Icon type="m-zhinengsoutu" />
        </div>
      </UploadImg>
    </div>
  )
}
